import { createContext, useContext, useMemo, useState } from "react";
import en from "../locales/en.json";
import ja from "../locales/ja.json";
import { getLocaleFromQuery } from "../utils/getLocaleFromQuery";

const dictionaries = { en, ja };

const LocaleContext = createContext(null);

function resolveKey(dict, key) {
  return key.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), dict);
}

export function LocaleProvider({ children }) {
  const [locale] = useState(getLocaleFromQuery);

  const t = useMemo(() => {
    const dict = dictionaries[locale] || dictionaries.en;
    return (key) => resolveKey(dict, key) ?? key; // falls back to the key itself if missing
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, t }}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale must be used within a LocaleProvider");
  return ctx;
}